import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "@phosphor-icons/react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

export function BlogList() {
  const { lang } = useI18n();
  const [rows, setRows] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/blog?lang=${lang}`);
        setRows(data);
      } catch {}
    })();
  }, [lang]);
  return (
    <div className="space-y-6" data-testid="blog-list-page">
      <div>
        <div className="text-xs uppercase tracking-widest font-bold text-stone-500">Mandi Gyan</div>
        <div className="font-display text-2xl font-bold text-stone-900">Sharper trader, every week</div>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {rows === null && Array.from({ length: 3 }).map((_, i) => <div key={i} className="rounded-xl bg-white border border-stone-200 h-72 shimmer" />)}
        {rows && rows.length === 0 && <div className="col-span-full rounded-xl bg-white border border-stone-200 p-10 text-center text-stone-500">No articles yet.</div>}
        {rows && rows.map((p, i) => (
          <motion.div key={p.id} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}>
            <Link to={`/app/blog/${p.slug}`} className="lift block rounded-xl overflow-hidden bg-white border border-stone-200 group" data-testid={`blog-card-${p.id}`}>
              {p.cover_image && <img src={p.cover_image} alt={p.title} className="w-full h-40 object-cover" />}
              <div className="p-5">
                <div className="text-[10px] font-bold uppercase tracking-widest text-orange-600">{p.category}</div>
                <div className="mt-2 font-display text-lg font-bold text-stone-900 group-hover:text-emerald-900 transition-colors">{p.title}</div>
                <p className="mt-2 text-sm text-stone-600 line-clamp-3">{p.excerpt}</p>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export function BlogArticle() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => { (async () => { try { const { data } = await api.get(`/blog/${slug}`); setP(data); } catch {} })(); }, [slug]);
  if (!p) return <div className="h-96 rounded-xl shimmer" />;
  return (
    <div className="max-w-3xl mx-auto space-y-6" data-testid="blog-article-page">
      <Link to="/app/blog" className="inline-flex items-center gap-2 text-sm font-semibold text-stone-600 hover:text-emerald-900"><ArrowLeft size={16} /> Back to Mandi Gyan</Link>
      {p.cover_image && <img src={p.cover_image} alt={p.title} className="w-full h-72 object-cover rounded-xl border border-stone-200" />}
      <div>
        <div className="text-[10px] font-bold uppercase tracking-widest text-orange-600">{p.category}</div>
        <h1 className="font-display text-4xl font-black tracking-tight text-emerald-950 mt-2">{p.title}</h1>
        <div className="text-sm text-stone-500 mt-2 font-mono">{new Date(p.published_at).toLocaleDateString("en-IN")}</div>
      </div>
      <div className="prose max-w-none text-stone-800 whitespace-pre-line leading-relaxed">{p.content}</div>
    </div>
  );
}
